import React, { Component } from 'react';
import { find, get } from 'lodash';

import '../css/dropdown.css';

class DropdownInput extends Component {
  constructor(props) {
    super(props);

    let value = this.inputValue;
    if (!value && props.defaultValue !== undefined) {
      value = props.defaultValue;
    };

    const option = this.findOptionForValue(value);
    let optionText = '';

    this.bindFunctionality();

    if (option) {
      optionText = wrapOptionText(option);
    }

    this.state = {
      value,
      text: optionText,
    };
  }

  get inputValue() {
    return get(this.props, 'input.value') || get(this.props, 'value', null);
  }

  get inputOnChange() {
    return get(this.props, 'input.onChange') || get(this.props, 'onChange', null);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input && nextProps.input.value !== this.state.value) {
      this.changeValue(nextProps.input.value);
    }
  }

  onOptionClick(value) {
    this.changeValue(value);
  }

  bindFunctionality() {
    this.onOptionClick = this.onOptionClick.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  findOptionForValue(value) {
    return find(this.props.options, opt => opt.value === value);
  }

  changeValue(value) {
    const onChange = this.inputOnChange;
    const option = this.findOptionForValue(value);
    if (!option) return;
    const text = wrapOptionText(option);
    this.setState({ value, text });
    onChange(makeEvent(value));
  }

  renderOption({ value, text, hint, className }) {
    const onClick = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.onOptionClick(value);
    };

    const selected = value === this.state.value ? 'selected' : '';
    const classNames = `dropdown-item justify-content-between ${className} ${selected}`;

    return (
      <div className={classNames} key={value} onClick={onClick}>
        <a href="#dropdown-item">
          <b>{text}</b>
          {' '}
          <span className="small-print">{hint}</span>
        </a>
      </div>
    );
  }

  render() {
    const className = `dropdown pbg-dropdown ${this.props.className || ''}`;

    return (
      <div className={className}>
        <button type="button" className="btn btn-secondary" data-toggle="dropdown">
          {this.state.text}
          <i className="fa fa-fw fa-angle-down" />
        </button>
        <div className="dropdown-menu">
          {this.props.options.map(this.renderOption)}
        </div>
      </div>
    );
  }
}

const makeEvent = value => ({
  stopPropagation() {},
  preventDefault() {},
  target: { value },
});

const wrapOptionText = option => <span className={option.className}>{option.text}</span>;

export default DropdownInput;



// WEBPACK FOOTER //
// ./src/desktop/components/dropdown.js